import React,{useState} from 'react';

import BackButton from '../../components/back-button';
import {avatarUrl, getOrdinalCode, hasFullAccessToProductType, OfferingType, showSetFocusArea} from '../../utils/web-helper';
import i18n from '../../utils/i18n';
import LanguageKey from '../../utils/locale-class';
import DeleteConsentPopup from './delete-consent-popup';
import PageHead from '../common/page-head/PageHead';
import { SHOW_DELETE_ICON_B2B, unlockCtaTextMapping } from '../../constant-data/constants';
import {isAvtarGamificationAssigned, isBooksMonetizationVariant, showNewUnlockBanner, getPermanentNudgeCtaText} from '../../utils/feature_mapping';
import UnlockContentBanner from '../common/unlock-content-banner';

const ErrorMessages = {
  name: "Please provide nickname, it's mandatory.",
  avatarCode: "Please select an avatar, it's mandatory",
  gradeId: "Please select grade, it's mandatory.",
  contentGroupIds: "Please select topic, it's mandatory."
}

export default function StudentForm({ currentGrades, subjects, form, currentCourses, formHandler, avatars, grades, contentGroups, goBack, submitHandler, submitDisabled, backHandler, allStudentCourses, selectedContentGroups, studentSettings, toggleSetting, mathFactSettings, showMFInDailyLPSetting, isClassroomStudent, students, student }) {
  const hasAccessToBooks = hasFullAccessToProductType(OfferingType.books);
  const hasAccessToLP = hasFullAccessToProductType(OfferingType.lp);
  const showUnlockBanner = showNewUnlockBanner() && !hasAccessToLP;
  // [AI GENERATED CODE] Use getPermanentNudgeCtaText to align CTA text with Flutter permanentNudgeCtaText logic
  const unlockCtaText = (hasAccessToBooks || hasAccessToLP) ? unlockCtaTextMapping.upgrade : getPermanentNudgeCtaText(unlockCtaTextMapping.unlockFullAccess);

  return (
    <div className={`parent-onboarding add-child-details routes-container ${showUnlockBanner ? 'unlock-access-banner' : ''}`}>
      {showUnlockBanner && (
        <>
          <UnlockContentBanner
            ctaText={unlockCtaText}
            ctaPosition="right"
            bannerPosition="top"
            from='editProfile'
            showIcon={hasAccessToBooks} // showing icon only for upgrade flow
          />
        </>
      )}
      <BackButton backHandler={backHandler} />
      <div className="">
        <div className="container">
         <PageHead>
            <Header goBack={goBack} form={form} />
          </PageHead>
          {(location.hash.includes('add')||(!form.haveAddedChild || !location.hash.includes('home')))&&<NameAndAvatar
            form={form}
            avatars={avatars}
            avatarSelectHandler={formHandler.avatarSelectHandler}
            nameChangeHandler={formHandler.nameChangeHandler}
            isClassroomStudent={isClassroomStudent}
            students={students}
            student={student}
          />}
          {form.haveAddedChild &&
            subjects.map((subject, index) => {
              return (
                <CourseComponent key={subject.id + index} currentGrade={currentGrades[subject.id]} subject={subject} form={form} grades={grades} formHandler={formHandler} contentGroups={contentGroups} allStudentCourses={allStudentCourses} selectedContentGroups={selectedContentGroups} studentSettings={studentSettings} index={index} toggleSetting={toggleSetting} mathFactSettings={mathFactSettings} showMFInDailyLPSetting={showMFInDailyLPSetting} showUnlockBanner={showUnlockBanner}/>
              );
            })
          }
          <SubmitButton submitHandler={submitHandler} submitDisabled={submitDisabled}/>
        </div>
      </div>
    </div>
  )
}

function CourseComponent ({selectedContentGroups, currentGrade, subject, form, grades, formHandler, contentGroups, allStudentCourses, studentSettings, index, toggleSetting, mathFactSettings, showMFInDailyLPSetting, showUnlockBanner}) {
  var subjectName = subject.title;

  let accessType = studentSettings[`has_${subject.code}_access`] ? 'Full Access' : 'Limited Access';
  return (
    <div className="edit-grade-topic-wrapper math" style={{textAlign: 'center', 'background': '#fff'}}>
      {!showUnlockBanner &&
        <p className={'access-badge ' + (studentSettings[`has_${subject.code}_access`] ? 'ful-acc' : '')}>
          <i className={studentSettings[`has_${subject.code}_access`] ? 'iconcust-iconTick2' : 'iconcust-iconLockSolid'} />
          {accessType}
        </p>
      }
      <p className="title">
        {subjectName}
        {showUnlockBanner &&
          <span className='new-access-badge'>
            {accessType}
          </span>
        }
      </p>
      {(location.hash.includes('add') || !location.hash.includes('home')) && <GradeSelection validateGrade={index==0} currentGrade={currentGrade} subject={subject} form={form} grades={grades} selectHandler={ formHandler.gradeSelectHandler} />}
      {showSetFocusArea(subject.code) && !isBooksMonetizationVariant() &&
        <>
          <TopicSelection form={form} selectedContentGroups={selectedContentGroups} contentGroups={contentGroups} selectHandler={formHandler.topicSelectHandler} currentGrade={currentGrade} allStudentCourses={allStudentCourses} subject={subject} />
        </>
      }
      { subject.code === 'math' &&
        <MathFactSettings toggleSetting={toggleSetting} mathFactSettings={mathFactSettings} showMFInDailyLPSetting={showMFInDailyLPSetting}/>
      }
    </div>
  )
}

function Header({goBack, form}) {
  return (
    <div className="page-heading">
      {location.hash.includes('add') || !form.haveAddedChild || !location.hash.includes('home')? `Enter ${form.name || "your child"}'s details`:'Select Preferred Topics'}
    </div>
  )
}

function NameAndAvatar({form, avatars, avatarSelectHandler, nameChangeHandler, isClassroomStudent, students, student}) {
  // state to show or hide delete consent popup
  const [showDeleteConsentPopup, setShowDeleteConsentPopup] = useState(false)
  var AvatarBox = function(avatar) {
    var selected = form.avatarCode == avatar ? "active" : "";
    return (
      <li id="avatar" className={selected} key={avatar} data-avatar="avatar">
        <a className="img-wrap " role="button" onClick={(e) => avatarSelectHandler(avatar)}>
          <img alt="avatar" src={avatarUrl(avatar)} className="" />
        </a>
      </li>
    )
  }
  return(
    <div className="name-avatar-wrap add-child-name-wrap">
      <div className={form.error.name ? 'error' : ''}>
        {SHOW_DELETE_ICON_B2B && form.studentId && (form.studentId!="") && isClassroomStudent && <div className="delete-icon" onClick={() => {setShowDeleteConsentPopup(true)}}></div>}
        {/* delete consent popup */}
        {SHOW_DELETE_ICON_B2B && form.studentId && (form.studentId!="") && isClassroomStudent && showDeleteConsentPopup &&
        <DeleteConsentPopup
        setShowDeleteConsentPopup={setShowDeleteConsentPopup}
        childName={form.name}
        students={students}
        student={student}
        />}
        <h6>Enter Nickname</h6>
        <input type="text" value={form.name} onChange={ nameChangeHandler } data-name="name"/>
        {form.error.name &&
          <p style={{paddingBottom: '1rem'}}>{ErrorMessages.name}</p>
        }
      </div>
      {!isAvtarGamificationAssigned() && <div className={form.error.avatarCode ? 'error' : ''}>
        <h6>Select Avatar</h6>
        <ul className="avatar-wrapper clearfix test">
          {avatars.map(AvatarBox)}
        </ul>
      </div>}
    </div>
  )
}

function GradeSelection({currentGrade, subject, form, grades, selectHandler, validateGrade}) {
  var gradeBox = function(grade){
    var isGradeAvailable = false;
    var courseId = '';
    grade.courses.map((course) => {
      if (course.subject_code == subject.code) {
        courseId = course.id;
        isGradeAvailable = true;
        return
      }
    });
    // [AI GENERATED CODE] - Added optional chaining to prevent undefined access
    const isYearLocale = ['en-GB', 'en-AU'].includes(i18n.language);
    const ordinalGrade = grade.ordinal_code || getOrdinalCode(grade.code.toLowerCase());
    const isLocaleClass = ordinalGrade.match(/Pre-K/i) && isYearLocale;
    const isAULocale = isLocaleClass && i18n.language === 'en-AU';
    const isKLocaleClass = ordinalGrade === 'K' && i18n.language === 'en-AU';
    var selectedClass = form.subjectForms?.[subject.id]?.courseId == courseId ? 'select' : '';
    return (
      <li className={selectedClass + (isGradeAvailable ? "" : "unavailable")} data-grade="grade" key={ordinalGrade}>
        { !isGradeAvailable &&
          <p className="coming-soon-text">Coming Soon</p>
        }
        <a className={`${isLocaleClass ? ('grade-Pre-K-locale ' + (isAULocale && 'grade-Pre-K-locale-au' || '')) : ''} ${'grade-' + ordinalGrade} ${isKLocaleClass ? 'grade-K-locale' : ''}`} role="button" onClick={(e) => selectHandler(courseId, subject.id)} >
          { isYearLocale ?
            <React.Fragment>
              { isLocaleClass || isKLocaleClass ? null : i18n.t('onboarding.grade.grade') }
              <strong>{i18n.t('onboarding.grade.' + ordinalGrade)}</strong>
            </React.Fragment> :
            <React.Fragment>
              <strong>{i18n.t('onboarding.grade.' + ordinalGrade)}</strong>
              { i18n.t('onboarding.grade.grade') }
            </React.Fragment>
          }
        </a>
      </li>
    )
  };
  return (
    <div className={"grade-selection " + (form.error.gradeId && validateGrade ? 'error' : '')}>
      <h2>Select {i18n.t('onboarding.grade.grade')}</h2>
      <ul className="grades-wrapper">
        {grades.map(gradeBox)}
      </ul>
      {form.error.gradeId && validateGrade &&
        <p className="error-msg">{ErrorMessages.gradeId}</p>
      }
    </div>
  )
}


// [AI GENERATED CODE] - Added optional chaining to prevent undefined access
function TopicSelection({form, selectedContentGroups, contentGroups, selectHandler, currentGrade, allStudentCourses, subject}){
  var courseId = form.subjectForms?.[subject.id]?.courseId;
  const course = allStudentCourses[courseId];
  const studentCourseContentGroup = form.subjectForms?.[subject.id]?.selectedTopics || [];
  if(!course || !course.focus_area_enabled){
    return <div />
  }
  var ContentGroupBox = function(contentGroup){
    var isSelected = studentCourseContentGroup.find((contentGroupId) => contentGroupId === contentGroup.id);

    return (<li className={isSelected ? 'select' : ''} key={contentGroup.id} data-group="group">
      <a role="button" onClick={ (e) => selectHandler(contentGroup.id, subject.id) }>
        <span>{contentGroup.title}</span>
        <div className={"img-wrap " + contentGroup.code}>

        </div>
      </a>
    </li>)
  };
  return (
    <div className={"topic-selection " + (form.error.contentGroupIds ? 'error' : '')}>
      {(location.hash.includes('add') || !location.hash.includes('home'))&&<h2>Select Active Topic on Learning Path</h2>}
      <ul className={"topics-wrapper grade-" + String(currentGrade).toUpperCase() + ' cg-' + LanguageKey()}>
        {contentGroups[courseId].map(ContentGroupBox)}
      </ul>
      {form.error.contentGroupIds &&
        <p className="error-msg">{ErrorMessages.contentGroupIds}</p>
      }
    </div>
  )

}

export function SubmitButton({submitHandler, submitDisabled, cancelHandler}) {
  // var disableClass = submitDisabled ? 'disable' : '';
  const onCancelAddChildForm = () => {
    if (window.location.search.includes('set_goal=1')) {
      return window.location = '/';
    }
    if(cancelHandler) {
      return location.hash = "/settings"
    }
    location.hash = '/';
  }
  return (
    <div className="submit-or-cancel-container">
      <div className="submit-or-cancel-wrap">
        <a className="cancel-btn" onClick={onCancelAddChildForm}>Cancel</a>
        <div className="submit-cta">
          <a role="button" onClick={submitHandler} className="button rounded-button-light-orange">Save Changes</a>
        </div>
      </div>
    </div>
  )
}


function MathFactSettings({toggleSetting, mathFactSettings, showMFInDailyLPSetting}) {
  return (
    <ul className='math-fact-settings'>

      <li>
        <p>Allow multiple attempts on a wrong answer</p>
        <span className={'toggle-button ' + (mathFactSettings['allowMultipleAttempts'] ? 'on' : 'off')} onClick={() => toggleSetting('allowMultipleAttempts')}>
        </span>
      </li>
    </ul>
  )
}
